<ng-template #modalTmpl>
  <h1 mat-dialog-title>
    {{ 'modals.provide-additional-doc.title' | transloco }}
  </h1>

  <div mat-dialog-content class="max-h-80vh px-16px max-w-450px">
    <form [formGroup]="form" class="relative px-1px">
      <ib-spinner
        *ngIf="!isDevicesInited"
        class="my-30px"
        [diameter]="30"
        [fluid]="true"
        class="bg-white z-10"
      ></ib-spinner>

      <div *ngIf="!docs?.length" class="my-24px">
        {{ 'page.sign-up.steps.3.descr' | transloco }}
      </div>

      <div
        *ngIf="docsMainFormGroup.invalid"
        class="my-36px"
        [ngClass]="[
          showDoubleSelection
            ? 'grid grid-cols-2 gap-5'
            : 'flex justify-center items-center'
        ]"
      >
        <div class="relative">
          <ib-upload
            [addedDocs]="docs"
            class="w-full"
            [disabled]="docsMainFormGroup.valid"
            btnClass="ib-btn ib-btn-secondary px-16px! flex-col ib-btn-outline  w-full w-max-160px h-80px!"
            (selected)="addDocs($event)"
          >
          </ib-upload>
          <ib-tooltip
            class="block mt-8px"
            text="{{
              ('comp.add-file.tooltip' | transloco) +
                (!showDoubleSelection
                  ? ('comp.make-photo.tooltip-or' | transloco)
                  : '')
            }}"
          >
          </ib-tooltip>
        </div>

        <div *ngIf="showDoubleSelection" class="relative">
          <ib-webcam
            class="block w-full"
            [disabled]="docsMainFormGroup.valid"
            btnClass="ib-btn-secondary px-16px! flex-col ib-btn-outline w-full w-max-160px h-80px!"
            (confirmed)="addDocs($event)"
          >
          </ib-webcam>
          <ib-tooltip
            class="block mt-8px"
            text="{{ 'comp.make-photo.tooltip' | transloco }}"
          >
            <!-- Make a photo of your document. Max
					size is 10 Mb -->
          </ib-tooltip>
        </div>
      </div>

      <div *ngIf="docs?.length" class="my-24px">
        <ib-selected-docs
          [docsMainFormGroup]="docsMainFormGroup"
          [setFocusToAdded]="true"
          [docs]="docs"
          [docsFormGroupsMap]="docsFormGroupsMap"
          (removeDoc)="removeDoc($event)"
        >
        </ib-selected-docs>
      </div>

      <div class="mt-36px">
        {{ 'page.sign-up.steps.3.doc-type-title' | transloco }}:
      </div>

      <mat-radio-group
        formControlName="{{ SIGN_UP_FIELDS.DOC_TYPE }}"
        required
        class="flex flex-col mt-8px"
      >
        <ng-container *ngFor="let doc of docTypes$ | async">
          <mat-radio-button [value]="doc.type" class="block cursor-pointer">
            {{ doc.translateKey | transloco }}
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>
    </form>

    <div
      *ngIf="docsMainFormGroup?.invalid && docsMainFormGroup?.touched"
      class="flex justify-center items-center my-16px"
    >
      <ib-input-error
        class="text-11px"
        [formCtrl]="docsMainFormGroup"
      ></ib-input-error>
    </div>
  </div>

  <div
    mat-dialog-actions
    class="border-t border-border-d flex justify-end items-center"
  >
    <div class="flex justify-end items-center grow">
      <button
        mat-button
        mat-dialog-close
        type="button"
        class="ib-btn-outline ib-btn-secondary mr-16px"
      >
        {{ 'btn.close' | transloco }}
      </button>
      <ib-btn-wrap btnType="link" [isLoading]="loading">
        <button
          mat-button
          type="button"
          (click)="postDoc()"
          [disabled]="form.invalid || docs?.length === 0 || loading"
          class="ib-btn-secondary"
        >
          {{ 'btn.confirm' | transloco }}
        </button>
      </ib-btn-wrap>
    </div>
  </div>
</ng-template>
